export const MAP_CONFIG = {
  TILE_LAYERS: {
    OPENSTREETMAP: {
      URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      ATTRIBUTION: '© OpenStreetMap contributors'
    },
    CARTODB_POSITRON: {
      URL: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      ATTRIBUTION: '© OpenStreetMap contributors © CARTO'
    },
    CARTODB_VOYAGER: {
      URL: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      ATTRIBUTION: '© OpenStreetMap contributors © CARTO'
    }
  },
  MARKERS: {
    DEFAULT_ICON: {
      iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
      iconSize: [25, 41] as [number, number],
      iconAnchor: [12, 41] as [number, number],
      popupAnchor: [1, -34] as [number, number],
      shadowSize: [41, 41] as [number, number]
    },
    SELECTED_ICON: {
      iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
      iconSize: [25, 41] as [number, number],
      iconAnchor: [12, 41] as [number, number],
      popupAnchor: [1, -34] as [number, number],
      shadowSize: [41, 41] as [number, number]
    }
  },
  DEFAULT_ZOOM: 10,
  FOCUS_ZOOM: 15
};
